<template lang='pug'>
.container-fluid.p-0.push-wrapper
	.container
		.row
			.col
				.row
					.col-12.my-header.font-weight-bold
						| Транзакции
	.container.mt-5
		.row
			.col-sm-6
				.white_block
					.main_amount {{ transactions.all_sum }} ₽
					.with_franchise_amount ({{ transactions.all_sum_profit }} ₽ за вычетом франшиз)
					.amount_label — Принесли Вам пользователи за последние 31 день
			.col-sm-6
				.white_block
					.main_amount {{ transactions.spending_all }} ₽
					| Из них: {{ transactions.spending_all_sum_real }} руб. | {{ transactions.spending_all_sum_bonus }} бон.
					.amount_label — Потратили Ваши пользователи за последние 31 день

	.container.mt-5
		.row
			.col
				h5 {{ selected_user ? `Пользователь id ${selected_user}` : 'Разбивка по пользователям' }}
		.row(v-if="loading")
			.col
				.spinner-border(role="status")
					span.sr-only Loading...
		.row.user(
			v-for="user of users_transactions",
			:class="{ red: user.balance.real + user.balance.bonus < 100 }"
		)
			.col(v-if="(selected_user && selected_user == user.id) || !selected_user")
				.white_block
					.id Пользователь №{{ user.id }}
					.name {{ user.name }}
					.email {{ user.email }}
					.user_balances
						| Баланс:
						.real {{ user.balance.real }} руб.
						.bonus {{ user.balance.bonus }} бон.
					.user_spend
						| Траты за 31 день:
						.real {{ user.spending_real }} руб.
						.bonus {{ user.spending_bonus }} бон.
					.transaction_amount За последние 31 день пользователь занёс {{ user.sum }} руб.
					.franchised_sum(v-if="user.franchised_sum") -50%, FR№{{ user.franchise_id }}
</template>
<script>
	import { Tooltip } from "element-ui";
	import moment from "moment";
	import apiDriver from "../../apiDriver";

	export default {
		components: {
			[Tooltip.name]: Tooltip,
		},

		data() {
			return {
				users_transactions: [],
				transactions: {
					all_sum: 0,
					spending_all: 0,
					spending_all_sum_bonus: 0,
					spending_all_sum_real: 0,
					all_sum_profit: 0,
				},
				loading: true,
				selected_user: undefined,
			};
		},

		computed: {},

		mounted() {
			this.load_users_transactions();
			if (this.$route.query.user_id) {
				this.selected_user = this.$route.query.user_id;
			}
		},

		methods: {
			async load_users_transactions() {
				this.loading = true;
				let u_ts = await apiDriver.admin.users.getTransactions();
				u_ts.all_sum_profit = 0;
				let franchise_id = this.$store.state.userData.franchise.id;
				if (franchise_id != 1) {
					u_ts.all_sum = u_ts.all_sum / 2;
					for (let u of u_ts.users) {
						u.sum = u.sum / 2;
						u.franchised_sum = true;
						for (let t of u.transactions) {
							t.amount = Number(t.amount) / 2;
						}
					}
				} else {
					u_ts.all_sum_profit = 0;
					for (let u of u_ts.users) {
						if (u.franchise_id != franchise_id) {
							u.sum = u.sum / 2;
							u.franchised_sum = true;
							for (let t of u.transactions) {
								t.amount = Number(t.amount) / 2;
							}
						}
						for (let t of u.transactions) {
							u_ts.all_sum_profit += Number(t.amount);
						}
					}
				}
				this.users_transactions = u_ts.users;
				u_ts.all_sum = new Intl.NumberFormat().format(u_ts.all_sum);
				u_ts.all_sum_profit = new Intl.NumberFormat().format(u_ts.all_sum_profit);
				u_ts.spending_all = new Intl.NumberFormat().format(u_ts.spending_all);
				u_ts.spending_all_sum_bonus = new Intl.NumberFormat().format(
					u_ts.spending_all_sum_bonus
				);
				u_ts.spending_all_sum_real = new Intl.NumberFormat().format(
					u_ts.spending_all_sum_real
				);
				this.transactions = u_ts;
				this.loading = false;
			},
		},
	};
</script>
<style scoped lang="stylus">
	div {
		cursor: default;
	}

	.my-header {
		font-size: 26pt;
	}

	.header-pre-push {
		font-size: 1.5rem;
	}

	.header-push {
		font-size: 1.5rem;
		color: black;
	}

	.main_amount {
		font-size: 26pt;
	}

	.user {
		&.red {
			.white_block {
				border-left: 2px solid red;
			}
		}

		.id {
			font-size: 10pt;
			color: gray;
		}

		.name {
			font-size: 16pt;
			display: inline-block;
		}

		.email {
			display: inline-block;
			margin-left: 10px;
			color: gray;
			position: relative;
			top: -2px;
		}

		.franchised_sum {
			position: absolute;
			top: 10px;
			right: 30px;
			background: #4CAF50;
			padding: 5px 10px;
			font-size: 10pt;
			border-radius: 5px;
			color: white;
		}

		.user_balances {
			border-left: 2px solid #eee;
			padding-left: 10px;
			margin: 10px 0;

			.real {
				display: inline-block;
			}

			.bonus {
				display: inline-block;
				margin-left: 10px;
				color: gray;
			}
		}
	}
</style>
